import { makeHttpClient, _unwrapAxiosResponse } from "./http";
import env from "@/environment/env.json";
import { ToastProgrammatic as Toast } from "buefy";
const exportLargeCount = 65000;
export default class ReportManagerDataService {
  private httpClient = makeHttpClient();
  generateTestRun(query: any) {
    return _unwrapAxiosResponse(
      this.httpClient.post<ReportManagerDataService>(
        env.reportManagerUrl + "test/run/",
        query
      )
    );
  }

  generateReportRun(
    query: any,
    ids: number[],
    reportRunId: number[],
    isBulkAction: boolean
  ) {
    const params = new URLSearchParams();
    if (ids.length > 0 && isBulkAction) {
      ids.map(id => {
        params.append("id", "" + id);
      });
      reportRunId.map(r_id => {
        params.append("report_run_id", "" + r_id);
      });
      params.append("isBulkAction", "" + isBulkAction);
      return _unwrapAxiosResponse(
        this.httpClient.post<ReportManagerDataService>(
          `${env.reportManagerUrl}report/run/list/?${params.toString()}`
        )
      );
    } else {
      return _unwrapAxiosResponse(
        this.httpClient.post<ReportManagerDataService>(
          `${env.reportManagerUrl}report/run/list/?${query}`
        )
      );
    }
  }
  exportReportRun(
    query: any,
    ids: number[],
    reportRunId: number[],
    isBulkAction: boolean,
    isCheckedAll: boolean
  ) {
    const params = new URLSearchParams();
    ids.map(id => {
      params.append("id", "" + id);
    });
    reportRunId.map(r_id => {
      params.append("report_run_id", "" + r_id);
    });
    params.append("isBulkAction", "" + isBulkAction);
    params.append("isCheckedAll", "" + isCheckedAll);

    const url = `${
      env.reportManagerUrl
    }report/run/export?${query}&${params.toString()}`;
    const successToast = Toast.open({
      indefinite: true,
      message: "Download in Progress!",
      type: "is-success"
    });
    this.httpClient
      .get(url, { responseType: "blob" })
      .then(({ data }) => {
        const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", "ReportList.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        successToast.close();
      })
      .catch(error => {
        successToast.close();
        Toast.open({
          message: "Download failed. Please try again or contact support.",
          type: "is-danger"
        });
      });
  }

  downloadTemplateFile(reportRunId: number, fileName: any) {
    const url = encodeURI(
      `${env.reportManagerUrl}report/run/template/export/?report_run_id=${reportRunId}&template_name=${fileName}`
    );
    this.httpClient
      .get(url, { responseType: "blob" })
      .then(response => {
        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data])
        );
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch(error => {
        Toast.open({
          message: "Download failed. Please try again or contact support.",
          type: "is-danger"
        });
      });
  }

  getGeneratedTestRun(query: any) {
    return _unwrapAxiosResponse(
      this.httpClient.get<ReportManagerDataService>(
        env.reportManagerUrl + "test/run/?" + query
      )
    );
  }

  getReportListData(query: any) {
    return _unwrapAxiosResponse(
      this.httpClient.get<ReportManagerDataService>(
        env.reportManagerUrl + "report/run/list/?" + query
      )
    );
  }

  generateBuildReport(id: number) {
    const url =
      env.reportManagerUrl + "report/run/generate/template/?report_run=" + id;
    return _unwrapAxiosResponse(this.httpClient.get(url));
  }

  loadComparableReportList(id: number, reportType: string) {
    const url =
      env.reportManagerUrl +
      "report/run/compare/?report_run_id=" +
      id +
      "&report_type=" +
      reportType;
    return _unwrapAxiosResponse(this.httpClient.get(url));
  }

  getReportRunCompareData(
    reportId: number,
    compareId: number,
    reportType: string,
    customerId: number
  ) {
    let headers = {};
    if (customerId) {
      headers = {
        headers: {
          "Content-Type": "multipart/form-data",
          tenant: customerId
        }
      };
    }
    const url =
      env.reportManagerUrl +
      "report/run/comparison/?c_id=" +
      reportId +
      "&r_id=" +
      compareId +
      "&report_type=" +
      reportType;
    return _unwrapAxiosResponse(this.httpClient.get(url, headers));
  }

  loadComparableTestReportList(id: number) {
    const url =
      env.reportManagerUrl +
      "report/run/compare/?report_run_id=" +
      id +
      "&report_type=test_run";
    return _unwrapAxiosResponse(this.httpClient.get(url));
  }

  saveComment(comment: string, reportId: number) {
    const params = new URLSearchParams();
    params.append("report_run_id", "" + reportId);
    params.append("comment", comment);
    return _unwrapAxiosResponse(
      this.httpClient.post<ReportManagerDataService>(
        `${
          env.reportManagerUrl
        }report/run/summary/comment/?${params.toString()}`
      )
    );
  }

  editComment(comment: any, reportId: number) {
    const params = new URLSearchParams();
    params.append("report_run_id", "" + reportId);
    params.append("comment", "" + comment.comment);
    params.append("comment_id", comment.id);

    return _unwrapAxiosResponse(
      this.httpClient.put<ReportManagerDataService>(
        `${
          env.reportManagerUrl
        }report/run/summary/comment/?${params.toString()}`
      )
    );
  }

  fetchAllComments(id: number) {
    const url =
      env.reportManagerUrl + "report/run/summary/comment/?report_run_id=" + id;
    return _unwrapAxiosResponse(this.httpClient.get(url));
  }

  exportCompareReport(
    reportId: number,
    compareId: number,
    reportType: string,
    customerId: number
  ) {
    const headers = {
      tenant: customerId
    };
    const url = encodeURI(
      `${env.reportManagerUrl}report/run/compare/export?r_id=${reportId}&c_id=${compareId}&report_type=${reportType}`
    );
    this.httpClient
      .get(url, { responseType: "blob", headers })
      .then(response => {
        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data])
        );
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", "comparedReport.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch(error => {
        Toast.open({
          message: "Download failed. Please try again or contact support.",
          type: "is-danger"
        });
      });
  }

  getTestRunById(id: number) {
    return _unwrapAxiosResponse(
      this.httpClient.get<ReportManagerDataService>(
        env.reportManagerUrl + "test/run/" + id + "/"
      )
    );
  }
  getReportRunSummaryById(reportRunId: number) {
    return _unwrapAxiosResponse(
      this.httpClient.get<ReportManagerDataService>(
        env.reportManagerUrl +
          "report/run/validation/summary/?report_run_id=" +
          reportRunId
      )
    );
  }

  getTestRunSummaryById(customerId: number, testId: number) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customerId
      }
    };
    return _unwrapAxiosResponse(
      this.httpClient.get<ReportManagerDataService>(
        env.reportManagerUrl + "test/validation/summary/?test_run_id=" + testId,
        headers
      )
    );
  }

  getTestReportedItemData(customerId: number, testId: number, query: any) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customerId
      }
    };
    return _unwrapAxiosResponse(
      this.httpClient.get<ReportManagerDataService>(
        env.reportManagerUrl +
          "test/validation/detail/?test_run_id=" +
          testId +
          "&" +
          query,
        headers
      )
    );
  }

  getReportedItemData(
    customerId: number,
    id: number,
    isTest: boolean,
    query: any,
    switch_customer_id: number
  ) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customerId
      }
    };
    if (switch_customer_id) {
      query = query + "&switch_customer_id=" + switch_customer_id;
    }
    let url = null;
    if (isTest) {
      url = env.reportManagerUrl + "test/validation/detail/?test_run_id=";
    } else {
      url =
        env.reportManagerUrl + "report/run/validation/detail/?report_run_id=";
    }
    return _unwrapAxiosResponse(
      this.httpClient.get<ReportManagerDataService>(url + id + query, headers)
    );
  }

  changeReportRunStatus(reportRunId: number, status: string, comment: any) {
    return _unwrapAxiosResponse(
      this.httpClient.post<ReportManagerDataService>(
        env.reportManagerUrl +
          "report/run/cam/approval?id=" +
          reportRunId +
          "&status=" +
          status +
          "&comment=" +
          comment
      )
    );
  }

  getConfigDropdown(reportId: number) {
    return _unwrapAxiosResponse(
      this.httpClient.get<ReportManagerDataService>(
        env.reportManagerUrl +
          "report/run/config/?report_run_id=" +
          reportId +
          "&report_type=report"
      )
    );
  }

  getConfigDropdownByReportDef(reportDefinitionId: number, testRunId: number) {
    return _unwrapAxiosResponse(
      this.httpClient.get<ReportManagerDataService>(
        env.reportManagerUrl +
          "report/run/config/?report_definition_id=" +
          reportDefinitionId +
          "&report_run_id=" +
          testRunId +
          "&report_type=test"
      )
    );
  }

  exportReport(
    customer: any,
    reportId: any,
    isTest: any,
    ids: number[],
    query: any,
    isExportedAll: boolean,
    columns: any,
    count: any,
    switchCustomerId: any
  ) {
    // Remove table_name from query
    if (query) {
      const queryParams = new URLSearchParams(
        query.startsWith("&") ? query.substring(1) : query
      );
      queryParams.delete("table_name");
      query = queryParams.toString() ? "&" + queryParams.toString() : "";
    }

    const params = new URLSearchParams();
    params.append("tenant", customer);
    params.append("columns", JSON.stringify(columns));
    params.append("count", count);
    if (switchCustomerId) {
      params.append("switch_customer_id", switchCustomerId);
    }
    if (ids.length == 0) {
      throw new Error("Please select at least one record.");
    } else {
      if (!isExportedAll) {
        ids.map(id => {
          params.append("records", "" + id);
        });
      }
      let url = null;
      if (isTest) {
        params.append("test_run_id", reportId);
        url = `${
          env.reportManagerUrl
        }test/run/summary/export?${params.toString()}`;
      } else {
        params.append("report_run_id", reportId);
        url = `${
          env.reportManagerUrl
        }report/run/summary/export?${params.toString()}`;
      }
      if (isExportedAll) {
        url = url + query + "&all_records=true";
      }
      const successToast = Toast.open({
        indefinite: true,
        message: "Download in Progress!",
        type: "is-success"
      });
      this.httpClient
        .get(url, { responseType: "blob" })
        .then(({ data }) => {
          const downloadUrl = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");
          if (count >= exportLargeCount) {
            return 1;
          } else {
            link.href = downloadUrl;
            link.setAttribute("download", "ReportedItems.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
            successToast.close();
          }
        })
        .catch(error => {
          successToast.close();
          Toast.open({
            message: "Download failed. Please try again or contact support.",
            type: "is-danger"
          });
        });
    }
  }

  changeReportReopenStatus(reportRunId: number, comment: any) {
    return _unwrapAxiosResponse(
      this.httpClient.post<ReportManagerDataService>(
        env.reportManagerUrl +
          "report/run/reopen/?id=" +
          reportRunId +
          "&reopen_reason=" +
          comment
      )
    );
  }

  applyUplift(summaryData: any) {
    const headers = {
      headers: {
        "Content-Type": "application/json"
      }
    };

    return _unwrapAxiosResponse(
      this.httpClient.post<ReportManagerDataService>(
        env.reportManagerUrl + "test/validation/apply/uplift/",
        JSON.stringify(summaryData),
        headers
      )
    );
  }

  revertUplift(run_type: string, run_id: string, stream_id: string) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    };

    const data = new FormData();
    data.append("run_type", run_type);
    data.append("run_id", run_id);
    data.append("stream_id", stream_id);

    return _unwrapAxiosResponse(
      this.httpClient.put<ReportManagerDataService>(
        env.reportManagerUrl + "test/validation/apply/uplift/",
        data,
        headers
      )
    );
  }
}
